<ng-template #investmentTileTpl let-investment>
  <liberro-investment-tile
    [investment]="investment"
    [shareColumns]="false"
    [selected]="!!selectedId && selectedId === investment.portfolioId"
    (portfolioSelected)="onPortfolioSelected($event)"
    type="investment-select"
  ></liberro-investment-tile>
</ng-template>

@if (variant === 'sheet') {
  <div class="investment-select-list">
    @for (investment of investments; track investment.portfolioId) {
      <ng-container *ngTemplateOutlet="investmentTileTpl; context: { $implicit: investment }"></ng-container>
    }
    @if (loading) {
      <liberro-spinner [show]="true" type="inline"></liberro-spinner>
    }
  </div>
} @else {
  <div nz-menu class="generic-dropdown-menu investment-select-menu ant-dropdown-menu">
    <div class="investment-select-scroll" (scroll)="onScroll($event)">
      @for (investment of investments; track investment.portfolioId) {
        <ng-container *ngTemplateOutlet="investmentTileTpl; context: { $implicit: investment }"></ng-container>
      }
      @if (loading) {
        <liberro-spinner [show]="true" type="inline"></liberro-spinner>
      }
    </div>
  </div>
}
